import innovate from '../assets/innovator.gif';
import miler from '../assets/miler.gif';
import newbie from '../assets/newbie.gif';
import mentor from '../assets/mentor.gif';
import manager from '../assets/manager.gif';
import team from '../assets/team.gif';

const categories = [
  {
    name: 'Innovator Award',
    img: innovate,
    description:
      "For the team members who showcase pioneering ideas and it's execution contribute to innovation in project or bring a novel solution for the client or team or within the organization.",
  },
  {
    name: 'Extra Miler Award',
    img: miler,
    description:
      'For the team members who consistently go above and beyond their call of duty or demonstrating exceptional dedication and effort.',
  },
  {
    name: 'Newbie Award',
    img: newbie,
    description:
      'For the newly joined team members who are within 1 year in the organization but have already made a significant impact in their project or task or contributed to their team and excelling in their roles.',
  },
  {
    name: 'Best Mentor Award',
    img: mentor,
    description:
      'To recognize those team members who serve as guiding lights for their colleagues, providing support and mentorship that helps others succeed. This award is extended to anyone regardless of their KPI demanding them to be a mentor.',
  },
  {
    name: 'Best Manager Award',
    img: manager,
    description:
      'This award is for the manager/leader, who leads the team. Those who have achieved incredibility, demonstrating outstanding leadership and management skills.',
  },
  {
    name: 'Best Team Award',
    img: team,
    description:
      'This award is to acknowledge the relentless squads within the organization, teams that consistently collaborate and have worked together to achieve remarkable results, client satisfaction, appreciation and set benchmark for the others.',
  },
];

export default categories;
